import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

function ProtectedRoute({ children }) {
  const { user } = useAuth()
  const location = useLocation()

  if (!user) {
    return <Navigate to={`/?next=${encodeURIComponent(location.pathname)}`} replace />
  }

  return children
}

export default ProtectedRoute
